import {
	StyledTagDiscount,
	StyledTagNew,
	StyledTagOnlyCase,
} from './VehicleTag.styled';

interface ITagProps extends React.HTMLAttributes<HTMLDivElement> {
	type: 'discount' | 'new' | 'onlyCase';
	discount?: number;
	inverted?: boolean;
}

const VehicleTag = ({ type, discount, ...props }: ITagProps) => {
	if (type === 'discount') {
		return (
			<StyledTagDiscount className={type} {...props}>
				{discount}%
			</StyledTagDiscount>
		);
	} else if (type === 'new') {
		return (
			<StyledTagNew className={type} {...props}>
				NEW
			</StyledTagNew>
		);
	} else if (type === 'onlyCase') {
		return (
			<StyledTagOnlyCase className={type} {...props}>
				Доступно в кейсе
			</StyledTagOnlyCase>
		);
	}
	return null;
};

export { VehicleTag };
